// Per-seller and per-product storefront special cases, keyed on database ids.
// One-off business arrangements, not general rules; the server-side
// counterparts live in app/Support/StorefrontOverrides.php.

// Cortex Brand: the only seller with a (lazy-loaded) Facebook pixel — see lib/facebook-pixel.js.
export const CORTEX_USER_ID = 46542;

// Obsidian: white/light colourways keep the normal product block instead of the "whiteout" treatment.
export const NO_WHITEOUT_USER_IDS = [101930];

// The Mystery Tee: its own choice layout and a single "It’s a mystery" colour, and no
// apparel resources (fit/care) section — the blank is a surprise.
export const MYSTERY_TEE_PRODUCT_ID = 2002;

// The Mystery Hat: a single "It’s a mystery" colour.
export const MYSTERY_HAT_PRODUCT_ID = 81505;

// Sidekick Pocket: one swatch per variant instead of the stationery choices.
export const SIDEKICK_POCKET_PRODUCT_ID = 103460;

// Cortex Theme System Journal: counts as chosen on load, so Add to Cart is ready without a pick.
export const PRESELECTED_PRODUCT_IDS = [53069];

// Product-page carousel videos, keyed on variant id (Sidekick Notepad, black paper).
export const CAROUSEL_VIDEOS_BY_VARIANT_ID = {
  16404980: [
    {
      videoUrl: "https://www.youtube-nocookie.com/embed/vMpGWDA_ih8",
      thumbnailUrl: "https://img.youtube.com/vi/vMpGWDA_ih8/mqdefault.jpg",
      label: "Sidekick Notepad, Video",
    },
  ],
};

// "No AI" / "Yes AI": always show the backorder ship-by copy, backordered or not.
export const BACKORDER_COPY_PRODUCT_IDS = [110262, 110263];
